exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_wks-ext.js
// module id = 285
// module chunks = 0